import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from './services/authentication.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as LogRocket from 'logrocket';
import { AlertsService, CLToastType } from '@clavisco/alerts';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'cl_gc_mlt_idc';

  constructor(private readonly authenticationService: AuthenticationService, 
    private readonly router: Router,
  private readonly alertsService: AlertsService) {
    if (environment.production) {
      LogRocket.init(environment.logRocketId);
    }
  }

  ngOnInit(): void {
    this.ListenRouterEvents();
  }

  /**
   * Listens to router events to handle specific navigation actions.
   */
  private ListenRouterEvents(): void {
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd)
    ).subscribe(e => {
      if (e.urlAfterRedirects === '/' && e.url !== e.urlAfterRedirects) 
      {
        this.alertsService.Toast({message: 'The page where you are trying to access does not exist. Please contact your administraror.', type: CLToastType.INFO});
      }
      else if(e.url === '/login')
      {
        this.authenticationService.LogOut();
      }
    });
  }
}
